import { render, staticRenderFns } from "./TiktokMobile.vue?vue&type=template&id=553a2edf&scoped=true&"
import script from "./TiktokMobile.vue?vue&type=script&lang=js&"
export * from "./TiktokMobile.vue?vue&type=script&lang=js&"
import style0 from "./TiktokMobile.vue?vue&type=style&index=0&id=553a2edf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553a2edf",
  null
  
)

export default component.exports